import { takeEveryApiCall, takeLatestApiCall } from '../../sagas/helpers'
import autoOfferRateTypes from './action-types'
import { fetchAutoOfferRateCSV, fetchAutoOfferRates } from './api'

export default function* root() {
  yield takeEveryApiCall(autoOfferRateTypes.ENTITIES_FETCH_BEGIN, fetchAutoOfferRates)
  yield takeLatestApiCall(autoOfferRateTypes.AUTO_OFFER_RATES_CSV_DOWNLOAD_BEGIN, fetchAutoOfferRateCSV)
}
